export const AMPLITUDE_LOCALHOST_PROXY_URL =
  'https://dev.partners.ada-music.com/2/httpapi';

export const AMPLITUDE_LOCALHOST_PROXY_ORIGIN =
  'https://dev.partners.ada-music.com';

export interface EngagementProxyUrls {
  serverUrl: string;
  cdnUrl: string;
  mediaUrl: string;
}

/**
 * Resolves first-party CloudFront proxy URLs for the Amplitude engagement SDK.
 * Matches cache behaviors in infra/resources/distribution.py.
 */
export function getEngagementProxyUrls(): EngagementProxyUrls {
  const origin = window.location.origin;
  const proxyOrigin = origin.includes('localhost')
    ? AMPLITUDE_LOCALHOST_PROXY_ORIGIN
    : origin;

  return {
    serverUrl: proxyOrigin,
    cdnUrl: proxyOrigin,
    mediaUrl: proxyOrigin,
  };
}
